import { useUserStore } from '@/store'
// 返回上一级
export const goBackPage = () => {
  const pages = getCurrentPages()
  const pagesLength = pages.length
  if (pagesLength > 1) {
    uni.navigateBack({
      delta: 1,
    })
  } else {
    uni.reLaunch({
      url: '/pages/index/index',
    })
  }
}

/**
 *拨打电话
 */
export const cellPhone = (phoneNumber:string) => {
  if(!phoneNumber)return
  uni.makePhoneCall({
    phoneNumber: phoneNumber 
  });
}
/**
 *复制内容
 */
export const copyData = (str:any) => {
  if(!str)return
  uni.setClipboardData({
    data: str,
    success: function () {
      uni.showToast({
        title: '复制成功',
        duration: 2000
      });
    }
  });
}

/**
 *查看地址
 */
export const openLocation = (latitude:number,longitude:number,name?:string) => {
  if(!latitude || !longitude)return
  uni.openLocation({
    latitude: latitude,
    longitude: longitude,
    name:name||'',
    success: function () {
      console.log('success');
    }
  });
}


/**
 *手机号344分段
 */
export const phoneNum344 = (s:string) => {
  console.log('sss',s)
  if(!s)return ''
  const phoneNum = (`${s}`).replace(/\D/g,'')
  const match = phoneNum.match(/^(\d{3})(\d{4})(\d{4})$/)
  console.log(match)
  if(match) {
    return `${match[1]} ${match[2]} ${match[3]}`
  }
}

/**
 *退出登录 清除信息
 */
export const clearLoginInfo = () => {
  useUserStore().clearUserInfo() // 清除用户信息
}
export const requireImg = (imgPath: string) => {
  return `${import.meta.env.VITE_IMAGE_BASEURL}${imgPath}.png`
  // return new URL(`../static/images/${imgPath}.png`, import.meta.url).href;
};